module.exports = __webpack_public_path__ + "img/yinpin1.2de84e18.png";